import * as Immutable from 'immutable';
import isNil from 'lodash/isNil';
import {createReducer} from 'redux-store';
import {returnEmptyIfNull as returnEmptyStringForNullableFields} from 'utils/string-utils';
import * as constants from '../constants/scenario-detail-constants';

import type {List, Map, MapOf} from 'immutable';
import type {ActionsMap} from 'redux-store';

type Scenario = MapOf<{
    active: boolean;
    roles: List<MapOf<{permissionGroupId: string}>>;
    scenarioId: string;
    recordingDeletionDays: unknown;
}>;

export type ScenarioDetailStore = {
    activity: List<unknown>;
    annotationIcons: List<unknown>;
    answers: List<unknown>;
    assets: List<unknown>;
    groupedAnnotations: List<unknown>;
    keyedOrganizations: MapOf<{
        viewer: List<
            MapOf<{
                userId?: string;
                roles?: List<
                    MapOf<{
                        permissionGroupId: string;
                    }>
                >;
                firstName?: string;
            }>
        >;
    }>;
    organization: Map<unknown, unknown>;
    organizations: List<unknown>;
    questions: List<unknown>;
    scenario: Scenario;
    scenarioAnnotations: List<unknown>;
    scenarioContributorDefaults: List<
        MapOf<{
            permissionGroupId: string;
            enabled: boolean;
        }>
    >;
    sessions: List<unknown>;
    sessionsCount: number;
    simulators: List<unknown>;
    users: Map<unknown, unknown>;
};

const initialState = (): ScenarioDetailStore => {
    return {
        activity: Immutable.List(),
        annotationIcons: Immutable.List(),
        answers: Immutable.List(),
        assets: Immutable.List(),
        groupedAnnotations: Immutable.List(),
        // @ts-expect-error TS2322: Type Map<unknown, unknown> is not assignable to type
        // MapOf<{
        //   viewer: List<MapOf<{
        //     userId?: string;
        //     roles?: List<MapOf<{
        //       permissionGroupId: string;
        //     }>>;
        //     firstName?: string;
        //   }>>;
        // }>
        keyedOrganizations: Immutable.Map(),
        organization: Immutable.Map(),
        organizations: Immutable.List(),
        questions: Immutable.List(),
        scenario: Immutable.Map() as Scenario,
        scenarioAnnotations: Immutable.List(),
        scenarioContributorDefaults: Immutable.List(),
        sessions: Immutable.List(),
        sessionsCount: 0,
        simulators: Immutable.List(),
        users: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<ScenarioDetailStore> = {
    [constants.SCENARIO_DETAIL_SUCCESS]: (state, action) => {
        const scenario = returnEmptyStringForNullableFields(action.data, ['overview', 'publicTitle', 'objectives']);

        return {
            scenario,
        };
    },
    [constants.SCENARIO_HISTORY_SUCCESS]: (state, action) => {
        const data = action.data;

        return {
            activity: data,
        };
    },
    [constants.SCENARIO_CONTRIBUTOR_DEFAULTS_SUCCESS]: (state, action) => {
        return {
            scenarioContributorDefaults: action.data,
        };
    },
    [constants.SCENARIO_ORGANIZATIONS_SUCCESS]: (state, action) => {
        return {
            organizations: action.data,
        };
    },
    [constants.SIMULATORS_SUCCESS]: (state, action) => {
        return {
            simulators: action.data,
        };
    },
    [constants.SCENARIO_USERS_SUCCESS]: (state, action) => {
        let users = state.users;
        users = users.set(action.key, action.data);
        return {
            users,
        };
    },
    [constants.SCENARIO_KEY_ORGANIZATIONS_SUCCESS]: (state, action) => {
        let keyedOrganizations = state.keyedOrganizations;
        keyedOrganizations = keyedOrganizations.set(action.key, action.data);
        return {
            keyedOrganizations,
        };
    },
    [constants.SCENARIO_USERS_RESET]: (state, action) => {
        let users = state.users;
        users = users.set(action.key, Immutable.List());
        return {
            users,
        };
    },
    [constants.UPDATE_SCENARIO_STATUS_SUCCESS]: (state, action) => {
        let scenario = state.scenario;
        if (isNil(scenario)) {
            return;
        }
        const active = action.data.get('active');
        scenario = scenario.set('active', active);

        return {
            scenario,
        };
    },
    [constants.GET_SCENARIO_SESSIONS_SUCCESS]: (state, action) => {
        return {
            sessions: action.data.get('rows'),
            sessionsCount: action.data.get('count'),
        };
    },
    [constants.DISPOSE_SCENARIO_DETAIL_STORE]: () => {
        return initialState();
    },
};

export default createReducer<ScenarioDetailStore>(initialState(), actionsMap);
